module.exports = __webpack_public_path__ + "static/img/banner2.195c32e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/banner2.jpg
// module id = YdqA
// module chunks = 1